/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {forkJoin, Observable, ReplaySubject, Subscription} from 'rxjs';
import {UserService} from '../user.service';
import {FeatureToggleService} from '../../guards/feature-toggle/feature-toggle.service';

@Injectable({
    providedIn: 'root'
})
export class DependencyLoadNotifierService {

    private isReady = new ReplaySubject<void>(1);

    get onReady(): Observable<void> {
        return this.isReady.asObservable();
    }

    constructor(private user: UserService,
                private featureToggle: FeatureToggleService) {

        forkJoin([
            this.user.onLoad,
            this.featureToggle.onLoad
        ])
                .subscribe(() => {
                    this.isReady.next();
                    this.isReady.complete();
                });
    }
}
